
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({ name: 'FadeTransition' })
export default class FadeTransition extends Vue {
  @Prop({ type: String, default: 'out-in' })
  private mode!: string;
}
